module.exports = __webpack_public_path__ + "img/gitarbg@2x.ae0cad23.png";